import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Plus, Minus } from "lucide-react";
import PageMeta from "@/components/PageMeta";

export default function FAQ() {
  const [faqs, setFaqs] = useState([]);
  const [open, setOpen] = useState({});
  const [section, setSection] = useState("All");
  useEffect(() => { api.get("/faqs").then(r => setFaqs(r.data)); }, []);
  const sections = ["All", ...Array.from(new Set(faqs.map(f => f.section)))];
  const shown = section === "All" ? faqs : faqs.filter(f => f.section === section);

  return (
    <div className="bg-ivory text-ink pt-32 pb-24 min-h-screen">
      <PageMeta title="FAQ · Frequently Asked Questions" description="Answers to the most common questions about LOOXS — the eleven chapters, orders, shipping, sizing, pre-orders, gift cards and reaching the concierge." />
      <div className="max-w-[1200px] mx-auto px-8 md:px-16">
        <div className="text-center mb-16">
          <p className="text-[10px] tracking-luxury uppercase text-goldDark mb-6">Enquiries</p>
          <h1 className="font-editorial text-5xl md:text-7xl leading-[0.95] tracking-tight">Frequently asked</h1>
          <div className="rule-gold w-32 mx-auto my-10" />
        </div>

        <div className="flex flex-wrap gap-3 mb-10 border-y border-black/10 py-4">
          {sections.map(s => (
            <button key={s} data-testid={`faq-section-${s}`} onClick={() => setSection(s)}
              className={`text-[11px] tracking-widest-plus uppercase px-3 py-1 ${section === s ? "bg-ink text-ivory" : "hover:text-goldDark"}`}>
              {s}
            </button>
          ))}
        </div>

        <div className="divide-y divide-black/10">
          {shown.map(f => (
            <button key={f.id || f.question} data-testid={`faq-${f.question.slice(0,10)}`}
              onClick={() => setOpen(o => ({ ...o, [f.question]: !o[f.question] }))}
              className="w-full py-6 text-left">
              <div className="flex items-start justify-between gap-6">
                <div className="flex-1">
                  <p className="text-[10px] tracking-widest-plus uppercase text-goldDark mb-2">{f.section}</p>
                  <p className="font-editorial text-xl md:text-2xl">{f.question}</p>
                  {open[f.question] && <p className="mt-4 text-ink/70 leading-relaxed">{f.answer}</p>}
                </div>
                <span className="text-goldDark mt-2">
                  {open[f.question] ? <Minus className="w-4 h-4" strokeWidth={1.25} /> : <Plus className="w-4 h-4" strokeWidth={1.25} />}
                </span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
